import { axiosInstance } from '@/rest'

const createBalanceApi = () => {
  return {
    /**
     * Fetch quote data.
     * @param {string} account_number - Account number.
     * @returns {Promise<BalanceData>} Balance data for provided account number.
     */
    current_balance_v2: (account_number) =>
      axiosInstance.get(`v2/balances/${account_number}/current_balance`),
  }
}

const balanceApi = createBalanceApi()

export { balanceApi }

/**
 * @typedef {BaseEventData & {
 *   account_type: string,
 *   long_equity_market_value: number,
 *   short_equity_market_value: number,
 *   marginable_security_market_value: number,
 *   long_option_market_value: number,
 *   short_option_market_value: number,
 *   non_marginable_security_market_value: number,
 *   total_position_market_value: number,
 *   margin_equity: number,
 *   total_equity: number,
 *   margin_requirement: number,
 *   cash_balance: number,
 *   margin_excess_equity: number,
 *   cash_excess_equity: number,
 *   regt_bp: number,
 *   margin_equity_percent: number,
 *   cash_requirement: number,
 *   cash_equity: number,
 *   option_bp_internal: number,
 *   stock_bp_internal: number,
 *   available_to_withdraw: number,
 *   long_equity_market_value_sod: number,
 *   short_equity_market_value_sod: number,
 *   long_option_market_value_sod: number,
 *   short_option_market_value_sod: number,
 *   total_equity_sod: number,
 *   net_balance_sod: number,
 *   margin_excess_equity_sod: number,
 *   cash_excess_equity_sod: number,
 *   option_bp_internal_sod: number,
 *   stock_bp_internal_sod: number,
 *   incomplete_data: boolean
 * }} BalanceData
 */

/**
 * @typedef {Object} BaseEventData
 * @property {string} eventType - The type of the event.
 * @property {string} eventSymbol - The symbol for the event.
 * @property {number} eventTime - The timestamp of the event.
 * @property {number} sequence - The sequence number of the event.
 * @property {number} timeNanoPart - The nano-part of the event time.
 */
